import { MutationTree } from "vuex";
import { PanelState } from "./panel.module";
import { MUTATIONS } from "@/constants/mutations";
import { GlobalPagination } from "@/interfaces/panel/global-pagination.model";

export const PANEL_MUTATIONS: MutationTree<PanelState> = {
    // active route page
    [MUTATIONS.panel.updateLoadingPanel](state, loading: boolean): void {
        state.loading = loading;
    },
    [MUTATIONS.panel.setGlobalPagination](state, pagination: GlobalPagination): void {
        state.globalPagination = pagination;
    },
    [MUTATIONS.panel.setGlobalActivePage](state, page: number): void {
        state.globalActivePage = page;
    },
    [MUTATIONS.panel.resetGlobalPagination](state): void {
        state.globalActivePage = 1;
        state.globalPagination = {
            page: 1,
            pages: 0,
            total: 0,
            limit: 50
        };
    },
    setUserStatement(state, payload: { logs: unknown[]; summary: { totalRiali: number; totalUSDT: number; totalLogs: number }; pagination: { page: number; pageSize: number; totalItems: number; totalPages: number; hasMore: boolean }; user?: unknown }): void {
        state.userStatement = {
            logs: payload.logs || [],
            summary: payload.summary || { totalRiali: 0, totalUSDT: 0, totalLogs: 0 },
            pagination: payload.pagination || { page: 1, pageSize: 50, totalItems: 0, totalPages: 0, hasMore: false },
            user: payload.user || null
        };
    },
};
